import Component from '../abstracts/Component';
import Cookies from 'js-cookie';

/**
 Chat component
 */
export default class ChatMIAWComponent extends Component {

  // common selectors, overridable
  get SELECTORS() {
    return {
      //miaw chat enabled
      chatEnabled: '#chatMIAWEnabled',
      // PS
      personalStylistPopUpTriggerTime: '#personalStylistPopUpTriggerTime',
      personalStylistBanner: '.live-chat-personal-stylist-cta',
      personalStylistStartChat: '.live-chat-personal-stylist-cta .start-chat',
      personalStylistCloseBtn: '.live-chat-personal-stylist-cta .vex-close',
      chatBalloon: '#embedded-messaging',
      chatBalloonButton: '#embeddedMessagingConversationButton',
      fixedBar: '#jsFixedBar',
    };
  }

  get CLASSES() {
    return {
      hidden: 'd-none'
    }
  }

  constructor() {
    super();
    this.chatEnabled = document.querySelector(this.SELECTORS.chatEnabled).value;
    this.personalStylistPopUpTriggerTime = document.querySelector(this.SELECTORS.personalStylistPopUpTriggerTime).value.replace('.', '').replace(',', '');
    this.chatBalloon = document.querySelector(this.SELECTORS.chatBalloon);
    this.chatBalloonButton = document.querySelector(this.SELECTORS.chatBalloonButton);
    this.personalStylistBanner = document.querySelector(this.SELECTORS.personalStylistBanner);
    this.personalStylistStartChat = document.querySelector(this.SELECTORS.personalStylistStartChat);
    this.personalStylistCloseBtn = document.querySelector(this.SELECTORS.personalStylistCloseBtn);
    this.fixedBar = document.querySelector(this.SELECTORS.fixedBar);
    this.hidePersonalStylistForPage = document.body.getAttribute("data-hide-personal-stylist");
  }

  readDOM() {
    return {
      chatBalloon: document.querySelector(this.SELECTORS.chatBalloon),
      chatBalloonButton: document.querySelector(this.SELECTORS.chatBalloonButton),
      personalStylistBanner : document.querySelector(this.SELECTORS.personalStylistBanner),
      personalStylistStartChat : document.querySelector(this.SELECTORS.personalStylistStartChat),
      personalStylistCloseBtn : document.querySelector(this.SELECTORS.personalStylistCloseBtn),
      fixedBar : document.querySelector(this.SELECTORS.fixedBar),
    }
  }

  // display PS button
  setupPersonalStylistDelayedPopup() {
    let isPSCookieSet = Cookies.get('hidePSBanner');
    // click start chat button
    if (this.dom.personalStylistBanner != null && isPSCookieSet !== 'true') {
      let ctx = this;
      setTimeout(() => {
        const isChatBalloonDisplayed = ctx.readDOM().chatBalloon != null && (ctx.readDOM().chatBalloonButton.style.display == "" || ctx.readDOM().chatBalloonButton.style.display != "none");
        if (isChatBalloonDisplayed) {
          ctx.readDOM().personalStylistBanner.classList.remove(ctx.CLASSES.hidden);
        }
      }, this.personalStylistPopUpTriggerTime );
    }
  }

  hidePersonalStylistBanner() {
    // hide banner/button
    if(this.personalStylistBanner && this.personalStylistBanner != null) {
      this.personalStylistBanner.classList.add(this.CLASSES.hidden);
      Cookies.set('hidePSBanner', 'true');
    }
  }

  raiseChatButton(bool) {
    if (bool == true ) {
      this.readDOM().chatBalloon.classList.add("live-chat-raise");
      this.readDOM().personalStylistBanner.classList.add("live-chat-raise");
    } else {
      this.readDOM().chatBalloon.classList.remove("live-chat-raise");
      this.readDOM().personalStylistBanner.classList.remove("live-chat-raise");
    }
  }

  bindEvents() {
    if(this.hidePersonalStylistForPage !== 'true') {
      // set PS as motivation in preChat, then launch
      const prechatFields = {
        "Type": {
          "value": "Personal_Stylist",
          "isEditableByEndUser": true
        }
      };

      this.dom.personalStylistStartChat.addEventListener('click', (e) => {
        e.preventDefault();
        const chatAPI = window.embeddedservice_bootstrap;
        chatAPI.prechatAPI.setVisiblePrechatFields(prechatFields);
        chatAPI.utilAPI.launchChat();
      })
    }

    let ctx = this;
    document.addEventListener('showFixedBar', function (event) {
      ctx.raiseChatButton(true);
    }, false);
    document.addEventListener('hideFixedBar', function (event) {
      ctx.raiseChatButton(false);
    }, false);
  }

  render() {
    // check if new chat is enabled
    // if is enabled let's launch PS
    if (this.chatEnabled === 'true') {
      this.dom = this.readDOM();
      this.bindEvents();
      if(this.hidePersonalStylistForPage !== 'true') {
        this.setupPersonalStylistDelayedPopup();
        this.dom.personalStylistCloseBtn.addEventListener('click', () => {
          this.hidePersonalStylistBanner();
        });
      }

      let ctx = this;
      setTimeout(() => {
        if(ctx.readDOM().fixedBar && ctx.readDOM().fixedBar.classList.contains('show-bar')){
            this.readDOM().chatBalloon.classList.add("live-chat-raise");
            this.readDOM().personalStylistBanner.classList.add("live-chat-raise");
        }
      }, 500 );
    }
  }
}
